// services/base/BaseService.ts

import apiClient from "../core/apiClient";



export class BaseService<T extends { id?: number }> {
  constructor(protected readonly baseUrl: string) {}

  async getAll(params?: Record<string, any>): Promise<T[]> {
    const response = await apiClient.get<T[]>(this.baseUrl, { params });
    return response.data;
  }

  async getAllSorted(orderBy: string, orderDesc: boolean = true, params?: Record<string, any>): Promise<T[]> {
    const response = await apiClient.get<T[]>(this.baseUrl, {
      params: {
        ...params,
        order_by: orderBy,
        order_desc: orderDesc,
      },
    });
    return response.data;
  }

  async getById(id: number): Promise<T> {
    const response = await apiClient.get<T>(`${this.baseUrl}/${id}`);
    return response.data;
  }
  async getByIds(ids: number[], idField: keyof T = "id" as keyof T): Promise<T[]> {
    const idsParam = ids.join(",");
    const response = await apiClient.get<T[]>(`${this.baseUrl}/ids/${idsParam}`);
    return response.data;
  }

  async create(data:Partial<T>): Promise<T> {
    const response = await apiClient.post<T>(this.baseUrl, data);
    return response.data;
  }

  async update(id: number, data: Partial<T>): Promise<T> {
    const response = await apiClient.put<T>(`${this.baseUrl}/${id}`, data);
    return response.data;
  }

  async partialUpdate(id: number, fields: Partial<T>): Promise<void> {
    await apiClient.patch(`${this.baseUrl}/${id}`, fields);
  }
  
  async bulkPartialUpdate(updates: Partial<T & { id: number }>[]): Promise<void> {
    await apiClient.patch(`${this.baseUrl}/bulk`, updates);
  }
  
  // 🆕 יצירה בכמויות גדולות - מחזירה את האובייקטים שנוצרו עם ID
  async bulkCreate(objects: Omit<T, 'id'>[]): Promise<T[]> {
    const response = await apiClient.post<T[]>(`${this.baseUrl}/bulk-create`, objects);
    return response.data;
  }


  // שמירת פונקציה זו לתאימות לאחור, אך לא נשתמש בה יותר
  async bulkUpsert(objects: Partial<T>[]): Promise<void> {
    await apiClient.post(`${this.baseUrl}/bulk-upsert`, objects);
  }

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }
}
